import React from 'react'
import { Box, Button } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import { Container, ErrorBox, StatusBox, SubNav } from '../styles'
import DateRangeFilter from './DateRangeFilter'

const ANALYTICS_LINKS = [
    { path: '/dashboard/analytics', label: 'Visão geral' },
    { path: '/dashboard/analytics/workshops', label: 'Oficinas' },
    { path: '/dashboard/analytics/users', label: 'Usuários' },
    { path: '/dashboard/analytics/reminders', label: 'Lembretes' },
    { path: '/dashboard/analytics/maintenance', label: 'Manutenção' },
    { path: '/dashboard/analytics/loyalty', label: 'Fidelidade' },
    { path: '/dashboard/analytics/campaigns', label: 'Campanhas' },
    { path: '/dashboard/analytics/events', label: 'Eventos' },
    { path: '/dashboard/analytics/system', label: 'Sistema' }
]

const AnalyticsPageShell = ({
    title,
    children,
    loading = false,
    error = null,
    showGranularity = false,
    showWorkshopId = false
}) => {
    const location = useLocation()

    return (
        <Container>
            <Box mb={2} fontWeight='bold' fontSize={{ xs: 'h7.fontSize', sm: 'h6.fontSize', md: 'h5.fontSize' }}>
                {title}
            </Box>
            <SubNav>
                {ANALYTICS_LINKS.map((link) => {
                    const selected =
                        link.path === '/dashboard/analytics'
                            ? location.pathname === link.path
                            : location.pathname.startsWith(link.path)
                    return (
                        <Button
                            key={link.path}
                            component={Link}
                            to={link.path}
                            size='small'
                            variant={selected ? 'contained' : 'outlined'}
                        >
                            {link.label}
                        </Button>
                    )
                })}
            </SubNav>
            <DateRangeFilter showGranularity={showGranularity} showWorkshopId={showWorkshopId} />
            {error && <ErrorBox>{error}</ErrorBox>}
            {loading && !error && <StatusBox>Carregando análises…</StatusBox>}
            {!loading && !error && children}
        </Container>
    )
}

export default AnalyticsPageShell
